import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery } from "@tanstack/react-query";

import { SaveButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, kpiUserRangeValidation } from "./kpi-user-range-schema";
import { getKPIUserRange, editKPIUserRange } from "services/data.kpi.service";
import KPIUserRangeInfo from "./components/KPIUserRangeInfo";
import { useLocation } from "react-router-dom";

function EditKPIUserRange() {
  const location = useLocation();
  const { name } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null)
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  useQuery({
    queryKey: ["kpi-user-range", { name }],
    queryFn: () => getKPIUserRange({ name }),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });

  const editKPIUserRangeMutation = useMutation(editKPIUserRange, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const form = useForm({
    defaultValues: {...initialValues, range: "0;0,0;0,0;0,0;0"},
    values:formValues,
    resolver: yupResolver(kpiUserRangeValidation),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, isSubmitting },
    setValue,
    reset,
  } = form;

  const infoProps = {
    mode: "EDIT",
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    const {range} = data;
    const splitRange = range.split(';').flatMap(item => item.split(','));
    //const isAscending = splitRange.filter(v => v !== "0").every((val, i, arr) => i === 0 || arr[i - 1] <= val);
    const isAscending = splitRange.filter(v => v !== "0").every((val, i, arr) => i === 0 || arr[i] === "0" || Number(arr[i-1]) <= Number(val));
    if (!isAscending){
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setAlert(<Error_ content="Invalid value, value must be in order" onChange={setAlert} />)
      return;
    }
    const filtered = splitRange.filter(v => v !== "0");
    const hasDuplicatesExcludingZero = new Set(filtered).size !== filtered.length;
    if (hasDuplicatesExcludingZero){
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setAlert(<Error_ content="Duplicate value" onChange={setAlert} />)
      return;
    }

    const pairs = [
      [1, 2],
      [3, 4],
      [5, 6]
    ];
  
    for (const [i, j] of pairs) {
      const val1 = splitRange[i];
      const val2 = splitRange[j];
      if ((val1 === "0" && val2 !== "0") || (val1 !== "0" && val2 === "0")) {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        setAlert(<Error_ content="Invalid value" onChange={setAlert} />)
        return;
      }
    }

    editKPIUserRangeMutation.mutate({originalName: name, ...data}, {
      onSuccess: () => {
      },
    });
  };
  const editStatus = editKPIUserRangeMutation.status === "loading";
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <KPIUserRangeInfo {...infoProps} />
        <SaveButton label="Save" disabled={!isDirty && editStatus} url="/kpi/kpi-user-range" />
      </form>
    </Layout>
  );
}

export default EditKPIUserRange;
